import React from 'react';


export default (props) => (
    <span className="LoadingIndicator">
        <span className="LoadingIndicator-icon"/>
    </span>
);



// WEBPACK FOOTER //
// ./src/common/misc/LoadingIndicator.jsx